import {
  actionButtonNavigationConfigType,
  ActionButtonOutcomesType,
  defaultNavigationConfig,
} from '../action-button-navigation-config.type';
import { ButtonActionType } from '../common.type';
import { APP_ZONES, NavigationOptionEnum } from '../workflow.type';
import { DummyRole } from '../workflow.v2.type';

export const profileNavigationConfigMap: Map<ButtonActionType, actionButtonNavigationConfigType> = new Map([
  [
    ButtonActionType.UPDATE_MARKETING_PREFERENCES,
    {
      [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
      [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
    },
  ],
  [
    ButtonActionType.SUBMIT_PROFILE_CHANGES_IN_PROFILE_ZONE,
    {
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.PROFILE,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'profile',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
    },
  ],
  [
    ButtonActionType.CLEAR_FORM_STATE_AND_REDIRECT_TO_EDIT_PROFILE,
    {
      [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
    },
  ],
  [
    ButtonActionType.TOGGLE_BIOMETRIC_AUTHENTICATION,
    {
      [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
    },
  ],
  [
    ButtonActionType.UPDATE_ORGANISATION,
    {
      [ActionButtonOutcomesType.SUCCESS]: defaultNavigationConfig,
      [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
    },
  ],
  [
    ButtonActionType.SUBMIT_USER_PROFILE_UPDATE,
    {
      [ActionButtonOutcomesType.SUCCESS]: {
        selectedZone: APP_ZONES.VERIFICATION,
        selectedRole: DummyRole.EMPTY_ROLE,
        selectedPageIndex: 0,
        selectedPageUrl: 'sumsub-workflow?type=personal',
        selectedPageId: '',
        tabRef: '',
        selectedBrowserBehaviour: '',
        externalUrl: '',
        selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
        pageTransition: 'forward',
      },
      [ActionButtonOutcomesType.FAILURE]: defaultNavigationConfig,
    },
  ],
]);
